import { memo } from 'react';
import { Handle, Position } from 'react-flow-renderer';
import { RiBuilding4Line } from 'react-icons/ri';

const CompanyNode = ({ data }) => (
    <div className="company-node">
        <RiBuilding4Line size={30} color="#ffffff" className="mb-2" />
        <div>{data.label}</div>

        <Handle type="target" position={Position.Top} />
        <Handle type="source" position={Position.Bottom} />
    </div>
);

export default memo(CompanyNode);
